import { FDPhoneInput } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';

const PhoneInput = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    readonly,
    required,
    size,
    value,
    labelPlacement,
    ...rest
  } = props;

  return (
    <FDPhoneInput
      {...useDataAttrs(rest)}
      alignSelf={alignSelf}
      disabled={disabled || readonly}
      error={error}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      {...rest}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur}
      onChange={(val) => (val === undefined ? onChange('') : onChange(val))}
      onFocus={onFocus}
      placeholder={placeholder}
      labelPlacement={labelPlacement}
      required={required}
      size={size}
      value={value === '' ? undefined : value}
    />
  );
};

PhoneInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  fullWidth: inputDefaultProps.fullWidth,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  placeholder: inputDefaultProps.placeholder,
  readonly: inputDefaultProps.readonly,
  required: inputDefaultProps.required,
};

PhoneInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: inputPropTypes.label,
  placeholder: inputPropTypes.placeholder,
  size: inputPropTypes.size.isRequired,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  value: inputPropTypes.value.isRequired,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  fullWidth: inputPropTypes.fullWidth,
  labelPlacement: inputPropTypes.labelPlacement,
  readonly: inputPropTypes.readonly,
  required: inputPropTypes.required,
};

const PhoneInputSmall = (props) => {
  return <PhoneInput {...props} size="sm" />;
};

const PhoneInputLarge = (props) => {
  return <PhoneInput {...props} size="lg" />;
};

export { PhoneInputSmall, PhoneInputLarge };
